module.exports = __webpack_public_path__ + "static/media/dash-img.95f43e0b.png";